import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from 'app/main/apps/auth/authentication.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  @BlockUI("page") blockUI: NgBlockUI;
  /**
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private _authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if ([401, 403].indexOf(err.status) !== -1) {
          // Integrator public links use Token auth against /api/library/*
          const isIntegratorFlow =
            this._router.url.startsWith('/integrator') ||
            request.url.includes('/api/library/') || request.url.includes('/api/court') || request.url.includes('/api/country') || request.url.includes('/api/state') || request.url.includes('/api/lga');

          if (!isIntegratorFlow) {
            // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
            this._router.navigate(['/pages/miscellaneous/not-authorized']);
          }

          // ? Can also logout and reload if needed
          // this._authenticationService.logout();
          // location.reload(true);
        }
        // throwError
        this.blockUI.stop();

        if (err.status === 0) {
          return throwError("Server Unavailable, Please Try Again!");
        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
